'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var FILTER_TYPE = exports.FILTER_TYPE = ['metadata', 'filteredChangeInfo', '@type'];
var FILTERED = exports.FILTERED = ['metadata', 'filteredChangeInfo', 'filtered'];
var AGENT_ID = exports.AGENT_ID = ['metadata', 'filteredChangeInfo', 'agentId'];

var TYPE = exports.TYPE = '@type';